import editor from './editor';
import markExplanations from './markExplanations';
import { browseFileModalComponent } from './modals/browseFileModal';
import documentImportModal from './modals/documentImportModal';
import selectCurriculumVersionModal from './modals/selectCurriculumVersionModal';
import selectMarkExplanationModal from './modals/selectMarkExplanationModal';
import termSelectionModal from './modals/termSelectionModal';
import linkButtonModalForm from './proWebsite/linkButtonModalForm';

export default angular
  .module('redactieComponents', [])
  .component('editor', editor)
  .component('renderMarkExplanations', markExplanations) // still in structurescreen
  .component('proWebsiteLinkButtonModalForm', linkButtonModalForm) // used in CustomLink.ts
  .component('selectCurriculumVersionModal', selectCurriculumVersionModal) // structurescreen
  .component('termSelectionModal', termSelectionModal) // termbutton.ts
  .component('documentImportModal', documentImportModal) // word import
  .component('selectMarkExplanationModal', selectMarkExplanationModal) // markButton.ts
  .component('browseFileModal', browseFileModalComponent); // globalDocumentRow
